import { ResponseTypes } from "./APIService";

const BASE_URL = process.env.REACT_APP_BASE_URL

export type MessageTypes = 'whatsapp' | 'viber'

export type APIRequestMessageSetup = {
    type: MessageTypes;
    api: string;
    token: string;
}

export const APISetupMessage = async (body: APIRequestMessageSetup): Promise<{status: boolean, message: string}> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    const URL: string = `${BASE_URL}/setup/api/v1/message`;
    const HEADER: RequestInit = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body)
    }

    const response = await fetch(URL, HEADER);
    const responseData = await response.json() as ResponseTypes;

    if (!response.ok){
        return {status: false, message: responseData.message}
    }

    return {status: true, message: responseData.message}
}